import { assertNotType, assertType } from '@noshiro/ts-utils';
export const isManagerObservable = (obs) => obs.kind !== 'sync child';
export const isRootObservable = (obs) => obs.kind === 'root';
export const isChildObservable = (obs) => obs.kind === 'sync child' || obs.kind === 'async child';
assertType();
assertNotType();
assertType();
assertNotType();
assertType();
assertNotType();
